import {
  useGetCruisePurchase,
  useCreateCruisePurchase,
} from 'api-hooks/order/cruise';
import { CruiseSaleModel } from 'api-hooks/sale/cruise';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import CruisePurchaseForm from './components/form';
import { CruisePurchaseFormType } from './components/form-type';

export type CruisePurchaseViewParams = {
  id: string;
  defaultValues?: CruisePurchaseFormType;
  cruiseSale?: CruiseSaleModel;
};

export default function CruisePurchaseView(
  props: NavigationProps<NavigationRoutes.CruisePurchasesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetCruisePurchase({
    id,
  });

  const { mutateAsync, error: errorMutate } = useCreateCruisePurchase();

  const cruisePurchase = data?.data;

  const onResolve = useApprovalableEdit('cruise-purchases');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <CruisePurchaseForm
            {...props}
            renderError={
              !!errorMutate &&
              !!errorMutate.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => errorMutate.message}
                  </Notification>
                  <SeparatorVertical $margin={8} />
                </>
              )
            }
            cruisePurchase={cruisePurchase}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
